export const CARD_GRADES = ['SS', 'S', 'A', 'B', 'C', 'D'] as const;

export type CardGrade = (typeof CARD_GRADES)[number];

// 사막 컨셉 속성
export const CARD_ATTRIBUTES = ['sand', 'sun', 'wind', 'oasis', 'sandstorm', 'star', 'ruins'] as const;
export type CardAttribute = (typeof CARD_ATTRIBUTES)[number];

// 카드 타입
export const CARD_TYPES = ['creature', 'spell', 'artifact'] as const;
export type CardType = (typeof CARD_TYPES)[number];

// 속성 아이콘 매핑
export const ATTRIBUTE_ICONS: Record<CardAttribute, string> = {
  sand: '🏜️',
  sun: '☀️',
  wind: '💨',
  oasis: '💧',
  sandstorm: '🌪️',
  star: '⭐',
  ruins: '🗿',
};

// 속성 이름 매핑
export const ATTRIBUTE_NAMES: Record<CardAttribute, string> = {
  sand: '모래',
  sun: '태양',
  wind: '바람',
  oasis: '오아시스',
  sandstorm: '모래폭풍',
  star: '별',
  ruins: '유적',
};

// 카드 타입 이름 매핑
export const CARD_TYPE_NAMES: Record<CardType, string> = {
  creature: '크리처',
  spell: '스펠',
  artifact: '아티팩트',
};

export interface CardSummary {
  id: number;
  name: string;
  image_url: string;
  grade: CardGrade;
  description: string;
  count: number;
  acquired_at?: string; // 카드 획득 시각 (ISO 8601 형식)
  // 전투 속성
  attack?: number;
  defense?: number;
  hp?: number;
  cost?: number;
  card_type?: CardType;
  attribute?: CardAttribute;
  skill_name?: string;
  skill_description?: string;
  skill_effect?: Record<string, unknown>;
}

export interface CardCountBreakdown {
  ssgrade_card_count: number;
  sgrade_card_count: number;
  agrade_card_count: number;
  bgrade_card_count: number;
  cgrade_card_count: number;
  dgrade_card_count: number;
}

export interface CardInventoryResponse {
  card_count: CardCountBreakdown;
  total_count: number;
  card_list: CardSummary[];
}

export interface DailyClaimResult {
  coinsEarned: number;
  total: number;
  lastClaimedAt: string;
}

export interface GachaDrawRequest {
  pulls: number;
}

export interface GachaDrawResult {
  cards: CardSummary[];
  totalCurrency: number;
}

export interface AttendanceClaimResult {
  coinsEarned: number;
  total: number;
  attendanceStreak: number;
  lastAttendanceDate: string;
}


